import {UserOutlined, DesktopOutlined } from "@ant-design/icons";
import "../HomePage.css";

const stepsInfo = [
    {
        title: "Step 1: Sign Up",
        description: "Create an account to get started with our service.",
        icon: <UserOutlined className="step-icon" />
    },
    {
        title: "Step 2: Customize",
        description: "Input your financial data and customize your preferences.",
        icon: <DesktopOutlined className="step-icon" />
    },
    {
        title: "Step 3: Enjoy",
        description: "Start using our features and enjoy the benefits!",
        icon: <span role="img" className="step-icon" aria-label="celebration">🎉</span>
    }
];


function Step({ stepIndex }) {
    return (
        <div className="step">
            <div className="step-icon-container">
                <div className="step-badge">
                    {stepIndex + 1}
                </div>
                {stepsInfo[stepIndex].icon}
            </div>
            <h3>{stepsInfo[stepIndex].title}</h3>
            <p>{stepsInfo[stepIndex].description}</p>
        </div>
    );
}

function HowItWorks() {
    return (
        <div>
            <div className="how-it-works">
                <h2>Learn How It Works, it's Easy as 1-2-3!</h2>
                <div className="how-it-works-steps">
                    {stepsInfo.map((_, index) => (
                        <Step key={index} stepIndex={index} />
                    ))}
                </div>
            </div>
        </div>
    )
}


export default HowItWorks;